import React, { Fragment } from 'react';
import * as Actions from 'groups/components/list/actions';

const GroupsActions = ({ company, subcompany, permissions, group, handleToggle }) => {
  return (
    <Fragment>
      {permissions['acl.custom_group.toggle'] && (
        <Actions.Toggle group={group} handleClick={handleToggle} />
      )}

      {permissions['acl.custom_group.update'] && (
        <Actions.Edit
          company={company}
          subcompany={subcompany}
          group={group}
          handleClick={handleToggle}
        />
      )}
    </Fragment>
  );
};

export default GroupsActions;



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/components/list/GroupsActions.js